import { render, staticRenderFns } from "./landing-aon.vue?vue&type=template&id=8153ced6&"
import script from "./landing-aon.vue?vue&type=script&lang=js&"
export * from "./landing-aon.vue?vue&type=script&lang=js&"
import style0 from "./landing-aon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports